<template>
  <button
    class="bg-primary py-2 px-4 rounded text-white w-full hover:contrast-150"
    :class="classList"
    :disabled="disabled"
    @click="$emit('onClick')"
  >
    <slot name="text"></slot>
  </button>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    classList: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
